import { ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Customer } from 'src/model/customer.model';
import { FileInterface } from 'src/model/file.interface';
import { EnlargeImageComponent } from '../enlarge-image/enlarge-image.component';

@Component({
	selector: 'app-album-component',
	templateUrl: './album-component.component.html',
	styleUrls: ['./album-component.component.scss'],
	standalone: false
})
export class AlbumComponentComponent implements OnInit {
	private cdr = inject(ChangeDetectorRef);
	protected sharedService = inject(SharedService);
	protected enums = inject(Enums);
	private restApi = inject(RestApiService);
	private constructApi = inject(ConstructAPI);

	@Input() docArr: FileInterface[] = [];
	@Input() viewCustomer: Customer;

	ngOnInit(): void {
		this.docArr.sort((a, b) => (a.lastModified > b.lastModified ? -1 : 1));
	}

	downloadFile(filename: string, customerId: number) {
		const encoded = encodeURIComponent(filename);
		const xhr = this.restApi.getRequest(this.constructApi.getFullFile(customerId, encoded));
		xhr.responseType = 'blob';
		xhr.onreadystatechange = () => {
			if (xhr.readyState === 4) {
				if (xhr.status == 200) {
					this.sharedService.generateDownloadLink(xhr, filename);
				} else {
					this.sharedService.openAlert('Some error occurred. Please try again later', ALERT_TYPE.DANGER);
				}
			}
		};
	}

	checkIsImage(contentType: string) {
		if (contentType.includes('image/') == true) return true;
		else return false;
	}

	checkCanConvertSupportingDoc(filename: string) {
		// if (filename.includes("application-form") || filename.includes("contact") == true && filename.includes("guarantor-form") == false)
		//   return true;
		if (filename.includes('application-form')) return true;
		else if (
			filename.includes('epf-statement') == false &&
			filename.includes('formj') == false &&
			filename.includes('consent-form') == false &&
			filename.includes('reference-form') == false &&
			filename.includes('ic/front') == false &&
			filename.includes('ic/back') == false &&
			filename.includes('contact') == false &&
			filename.includes('payslip') &&
			filename.includes('bank-statement') &&
			filename.includes('atm-card')
		)
			return true;
		else return false;
	}

	isContactConvertibleDoc(filename: string) {
		if (filename.includes('contact') && filename.includes('guarantor-form') == false) return true;
		else return false;
	}

	openEnlargeImageModal(fileName: string, index: number) {
		const modalRef = this.sharedService.openModal(EnlargeImageComponent, 'largeModal');
		modalRef.componentInstance.customerId = this.viewCustomer.ID;
		modalRef.componentInstance.fileList = this.docArr;
		modalRef.componentInstance.currentFileIndex = index;
		const encoded = encodeURIComponent(fileName);
		modalRef.componentInstance.fileName = encoded;

		//get confirmation
		modalRef.componentInstance.passEntry.subscribe(entry => {
			const isDirty = entry;

			// use the confirmation to do something

			if (isDirty == true) {
				this.docArr.splice(index, 1);
				this.cdr.detectChanges();
			}
		});
	}

	confirmDeleteFile(filename: string, index: number) {
		const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
		modalRef.componentInstance.message = 'Are you sure you want to delete this file (' + filename + ') ?';

		modalRef.result.then(confirm => {
			if (confirm) this.deleteFile(this.viewCustomer.ID, filename, index);
		});
	}

	confirmBeforeChangeType(customerID: number, filename: string, targetType: string) {
		const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
		modalRef.componentInstance.message = 'Are you sure you want to change this file type to ' + targetType.toUpperCase() + '?';

		modalRef.result.then(confirm => {
			if (confirm) this.changeFileType(customerID, filename, targetType);
		});
	}

	confirmBeforeContactPhotoChangeType(customerID: number, filename: string) {
		const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
		modalRef.componentInstance.message = 'Are you sure you want to change this file type to GUARANTOR FORM?';

		modalRef.result.then(confirm => {
			if (confirm) {
				const contactId = filename.split('/')[1];
				this.changeContactFileType(customerID, Number(contactId), filename, 'guarantorForm');
			}
		});
	}

	deleteFile(customerId: number, filename: string, index: number) {
		const encoded = encodeURIComponent(filename);
		const xhttp = this.restApi.deleteRequest(this.constructApi.getDeleteFile(customerId, encoded));
		xhttp.onreadystatechange = () => {
			if (xhttp.readyState == 4 && xhttp.status == 200) {
				// Typical action to be performed when the document is ready:
				this.sharedService.openAlert('Successfully deleted picture!', ALERT_TYPE.SUCCESS);
				// window.location.reload();

				this.docArr.splice(index, 1);
				this.cdr.detectChanges();
			}
		};
	}

	changeFileType(customerID: number, filename: string, targetType: string) {
		const xhr = this.restApi.patchRequest(this.constructApi.getChangeFileType(customerID, filename, targetType));
		xhr.onreadystatechange = () => {
			if (xhr.readyState == 4) {
				if (xhr.status == 200) {
					//if success emit;
					this.sharedService.openAlert('Successfully changed file type', ALERT_TYPE.SUCCESS);
					window.location.reload();
				} else this.sharedService.openErrorMessage(xhr);
			}
		};
	}

	changeContactFileType(customerID: number, contactId: number, filename: string, targetType: string) {
		const xhr = this.restApi.patchRequest(this.constructApi.getChangeContactFileType(customerID, contactId, filename, targetType));
		xhr.onreadystatechange = () => {
			if (xhr.readyState == 4) {
				if (xhr.status == 200) {
					//if success emit;
					this.sharedService.openAlert('Successfully changed file type', ALERT_TYPE.SUCCESS);
					window.location.reload();
				} else this.sharedService.openErrorMessage(xhr);
			}
		};
	}

	previewFile(filename: string) {
		// var modalRef = this.sharedService.openModal(PreviewPdfComponent, "largeModal");
		// modalRef.componentInstance.url = this.restApi.apiUrl + this.constructApi.getFullFile(this.viewCustomer.ID, filename);
		// modalRef.componentInstance.filename = filename;

		const encoded = encodeURIComponent(filename);
		window.open(this.restApi.apiUrl + this.constructApi.getFullFile(this.viewCustomer.ID, encoded));
	}
}
